export enum SIMULATIONTYPE {
  RT = "RT",
  VARIOTHERM = "Variotherm",
}
